module.exports = __webpack_public_path__ + "img/medal.d61003e3.svg";